import { BrowserModule } from "@angular/platform-browser";
import { CommonModule } from "@angular/common";
import {
  CUSTOM_ELEMENTS_SCHEMA,
  NO_ERRORS_SCHEMA,
  LOCALE_ID,
  NgModule,
  APP_INITIALIZER,
} from "@angular/core";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { HomeComponent } from "./Pages/home/home.component";
import { FooterComponent } from "./Layouts/footer/footer.component";

import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import { GlobalModule } from "./Global/global.module";

import { APP_CONFIG } from "./Services/config";
import { environment } from "../environments/environment";
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from "@angular/common/http";

import { WiSnackbarComponent } from "./Global/wi-snackbar/wi-snackbar.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { JwtInterceptor } from "./Services/authentification/helpers/jwt.interceptor";
import { HttpErrorInterceptor } from "./Services/http/http-error.interceptor";
import { LanguageInterceptor } from "./Services/http/language.interceptor";
import { TranslationModule } from "./translation/translation.module";
import { PipesModule } from "./shared/pipes/pipes.module";
import { NotFoundComponent } from "./Pages/not-found/not-found.component";
import { ProductsModule } from "./Pages/products/products.module";
import { UserAccountModule } from "./Pages/user-account/user-account.module";
import { ServiceWorkerModule } from "@angular/service-worker";
import { registerLocaleData } from "@angular/common";
import localeFr from "@angular/common/locales/fr";
import localeArDz from "@angular/common/locales/ar-DZ";
import { MenutItems } from "./shared/Core/menu/menu";
import { UrlService } from "./Services/url.service";

import { DirectiveModule } from "./shared/Directives/directive.module";
registerLocaleData(localeFr, "fr");
registerLocaleData(localeArDz, "ar-DZ");
import { rxStompServiceFactory } from "./rx-stomp-service-factory";
import { RxStompService } from "./rx-stomp.service";
import { RxStompConfig } from "@stomp/rx-stomp";
import { RecaptchaModule, RecaptchaFormsModule } from "ng-recaptcha-2";
// import {myRxStompConfigGuichet} from "./Services/rx-stomp-guichet.config";
import { RouterModule } from "@angular/router";
import { MainModule } from "./Main/main.module";
import { HomeModule } from "./Pages/home/home.module";
import { DomSanitizer } from "@angular/platform-browser";
import { LIB_CONFIG, SnackbarComponent } from "admin-common";
import {
  GeneralConditionComponent,
  LegalInformationComponent,
  PrivacyPolicyComponent,
} from "admin-common";
import { GeneralConditionsComponent } from "./Pages/home/useful-links-page/condition/general-conditions/general-conditions.component";
import { LegalNoticeComponent } from "./Pages/home/useful-links-page/legal-notice/legal-notice/legal-notice.component";
import { PrivacyPageComponent } from "./Pages/home/privacy-page/privacy-page/privacy-page.component";
import { LayoutModule } from "./Layouts/layout.module";
import { CartInitializerService } from "./Services/cartInitializer.service";

export function initializeCart(cartInitializer: CartInitializerService) {
  return () => cartInitializer.init();
}
@NgModule({
  declarations: [
    AppComponent,
    WiSnackbarComponent,
    NotFoundComponent,
    GeneralConditionsComponent,
    LegalNoticeComponent,
    PrivacyPageComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent],
  imports: [
    CommonModule,
    BrowserModule,
    MainModule,
    HomeModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    TranslationModule.forRoot(),
    ReactiveFormsModule,
    ProductsModule,
    UserAccountModule,
    GlobalModule,
    PipesModule,
    DirectiveModule,
    RecaptchaModule,
    GeneralConditionComponent,
    LegalInformationComponent,
    PrivacyPolicyComponent,
    RecaptchaFormsModule,
    ServiceWorkerModule.register("ngsw-worker.js", {
      enabled: environment.production,
    }),
    RouterModule,
    LegalInformationComponent,
    LayoutModule,
    SnackbarComponent,
  ],
  providers: [
    MenutItems,
    { provide: UrlService },
    { provide: LOCALE_ID, useValue: "fr-FR" },
    { provide: LIB_CONFIG, useValue: { assetBasePath: "/assets" } },
    { provide: APP_CONFIG, useValue: environment.apiEndpointConfig },
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LanguageInterceptor, multi: true },
    { provide: "googleTagManagerId", useValue: "GTM-52ZGM5P" },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeCart,
      deps: [CartInitializerService],
      multi: true,
    },
    //WebSocket conf
    {
      provide: RxStompConfig,
      // useValue: myRxStompConfigGuichet
    },
    {
      provide: RxStompService,
      useFactory: rxStompServiceFactory,
      deps: [RxStompConfig],
    },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {
  constructor(private domSanitizer: DomSanitizer) {}
}
